import _ from 'lodash';
import { mapState, mapActions } from 'vuex';
import Debug from '~/utils/debug';
import FormInput from '~/components/form-input/FormInput.vue';
import { login } from '~/utils/auth';
import { LOGIN_TYPES } from '~/utils/constants';

const debug = Debug('login');

export default {
  components: {
    'form-input': FormInput,
  },
  data() {
    return {
      email: '',
      password: '',
      loginError: null,
      rememberMe: false,
    };
  },
  computed: {
    ...mapState('auth', 'key'),
    ...mapState('publicConfig', {
      passwordResetUrl: state => (state.config && state.config.password_reset_url) || '',
    }),
  },
  mounted() {
    this.$nextTick(() => {
      const el = _.get(this, '$refs.email.$el', null);
      if (el) {
        el.querySelector('input').focus();
      }
    });
  },
  methods: {
    ...mapActions('publicConfig', ['updateConfig']),
    tryLogin() {
      this.error = null;

      if (!this.email && !this.password) {
        this.loginError = this.$t('pos.login.empty-credentials');
      } else {
        login(this.email, this.password, this.rememberMe)
          .then(() => {
            this.$emit('login-success', LOGIN_TYPES.EMAIL);
          })
          .catch(err => {
            debug.warn('login error: %o', err);
            this.loginError = err;
          });
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/components/login/email/Email.js